import { render, staticRenderFns } from "./BankcardManage.vue?vue&type=template&id=49d96de2&scoped=true"
import script from "./BankcardManage.vue?vue&type=script&lang=js"
export * from "./BankcardManage.vue?vue&type=script&lang=js"
import style0 from "./BankcardManage.vue?vue&type=style&index=0&id=49d96de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d96de2",
  null
  
)

export default component.exports